import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals'; // Optional: For performance metrics
import { RouterProvider } from 'react-router-dom';
import { createBrowserRouter } from 'react-router-dom';

import App from './App';
import Team from './Components/teamMembers';
import Body from './Components/Body';
import Products from './Components/Products';
import CertificatePage from './Components/Certificates';
import ContactUs from './Components/ContactUs';
import Temp from './Components/Temp';

const appRouter=createBrowserRouter([
  { 
      path: "/",
       element: <App />,
       children:[
          { 
              path: "/about us",
              element: <Team /> 
          },
          { 
              path: "/home",
              element: <Body /> 
          },
          { 
              path: "/",
              element: <Body /> 
          },
          { 
              path: "/products",
              element: <Products />,
              children:[
                  {
                      path:'products/category1',
                      element:<Temp/>
                  }
              ] 
          },
          { 
              path: "/certificates",
              element: <CertificatePage/> 
          },
          { 
              path: "/contact us",
              element: <ContactUs /> 
          },
       ] 
  },
  
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterProvider router={appRouter} />
);

reportWebVitals();
